import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from "mobx";
import { IStoreElement } from "types/store";
import { ExtendedNextPageContext } from "types/app";

export default class Settings implements IStoreElement {
  private ctx?: ExtendedNextPageContext;
  @observable settings = null;
  year = new Date().getFullYear();

  constructor() {
    makeObservable(this);
  }

  toJSON() {
    return { settings: this.settings };
  }

  @action
  async fetch(): Promise<void> {
    const { data, errors } = await this.ctx.api.methods.settings.main({
      regionID: this.ctx.store.location.regionID,
    });
    if (data && data.settings) {
      runInAction(() => {
        this.set(data.settings);
      });
    }

    if (errors) {
      throw new Error(JSON.stringify(errors));
    }
  }

  set(settings: Entity.Settings): void {
    this.settings = settings;
  }

  @computed
  get minPriceOrders(): { minSumPickup?: number; minSumDelivery?: number } {
    return {
      minSumPickup: this.settings?.minSumPickup,
      minSumDelivery: this.settings?.minSumDelivery,
    };
  }
}
